{
  "version": 1,
  "asset_id": "66a70876-75fe-4e04-bd8f-14f8df0ab7b1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/66a70876-75fe-4e04-bd8f-14f8df0ab7b1/homosassa-blue-metal-roof-installation-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/66a70876-75fe-4e04-bd8f-14f8df0ab7b1/homosassa-blue-metal-roof-installation-1200w.avif",
  "original_filename": "homosassa-blue-metal-roof-installation-1200w.avif",
  "size": 59998,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:42Z"
}
